import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { isEvArticle } from 'site-modules/editorial/utils/ev';
import { Link } from 'site-modules/shared/components/link/link';

export function ArticleEvToolLink({ categories, slug, className, isMobile }) {
  if (!isEvArticle({ slug, categories })) {
    return null;
  }

  return (
    <div className={classnames('article-ev-tool-link', className)} data-tracking-parent="article_ev_tool_link">
      <div className="heading-5 mb-0_75">Search EV tax credits and rebates in your area</div>
      <Button
        color="primary-b"
        size="lg"
        className={classnames('py-0_5 px-1 px-md-2 text-decoration-none text-white', {
          'w-100': isMobile,
        })}
        style={{
          whiteSpace: 'normal',
          fontWeight: '400',
          textTransform: 'none',
        }}
        tag={Link}
        to="/electric-car/tax-credits-rebates-incentives/"
        data-tracking-id="link_select_tool_select"
      >
        See Electric Vehicle Rebates
      </Button>
    </div>
  );
}

ArticleEvToolLink.propTypes = {
  slug: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

ArticleEvToolLink.defaultProps = {
  categories: [],
  className: null,
  isMobile: false,
};
